export const operationStepsPaths : string[] = [
  "operations.create_operation.header_path_characteristic",
  "operations.create_operation.header_path_config_points",
  "operations.create_operation.header_path_showcase_style",
  "operations.create_operation.header_path_showcase_banner",
  "operations.create_operation.header_path_gift_catalog",
  "operations.create_operation.header_path_gift_overview",
  "operations.create_operation.header_path_regulations",
];
